import manageKeyBindings from "@/mixins/manageKeyBindings";
import scrollTo from "@/mixins/scrollTo";
import vmodal from "@/packages/vmodal";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import localeData from "dayjs/plugin/localeData";
import relativeTime from "dayjs/plugin/relativeTime";
import Echo from "laravel-echo";
import moment from "moment";
import {extendMoment} from "moment-range";
import Pusher from "pusher-js";
import VCalendar from "v-calendar";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import VueTheMask from "vue-the-mask";
import router from "./apps/portal/router";
import store from "./apps/portal/store";
import Http from "./classes/Http";
import eventHandler from "./constants/eventHandler";
import spaEvents from "./constants/spaEvents";
import authed from "./mixins/authed";
import bus from "./mixins/bus";
import enums from "./mixins/enums";
import form from "./mixins/form";
import permissions from "./mixins/permissions";
import present from "./mixins/present";
import refs from "./mixins/refs";
import route from "./mixins/route";
import StringerMixin from "./packages/stringer/src/StringerMixin";

dayjs.extend(duration);
dayjs.extend(localeData);
dayjs.extend(relativeTime);

// Sentry.init({
// 	Vue,
// 	dsn: "https://7449b6c0d836430c9d39e4594f7bc110@o236549.ingest.sentry.io/4505161738420224",
// 	integrations: [
// 		new Sentry.BrowserTracing({
// 			routingInstrumentation: Sentry.vueRouterInstrumentation(router),
// 		}),
// 		new Sentry.Replay(),
// 	],
// 	// Performance Monitoring
// 	tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
// 	// Session Replay
// 	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
// 	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });


window.http = new Http("httpClient");
window.externalHttp = new Http("externalHttpClient");
window._ = require("lodash");
window.Qs = require("qs");
window.tween = require("@tweenjs/tween.js");
window.moment = extendMoment(moment);
window.dayjs = dayjs;
window.Pusher = Pusher;
window.Echo = new Echo({
	broadcaster: "reverb",
	key: window.socketsConfig.appKey,
	wsHost: window.socketsConfig.domain,
	// wsPort: window.socketsConfig.port,
	// wssPort: window.socketsConfig.port,
	// forceTLS: (window.socketsConfig.scheme ?? "https") === "https",
	// enabledTransports: ["ws", "wss"],
	authorizer: (channel, options) => {
		return {
			authorize: (socketId, callback) => {
				http().post(window.endpoints.broadcasting, {
					socket_id: socketId,
					channel_name: channel.name,
				})
					.then(response => {
						callback(false, response.data);
					})
					.catch(error => {
						callback(true, error);
					});
			},
		};
	},
});

Vue.component("app", require("./apps/portal/App.vue").default);
Vue.component("api-mode", require("./components/ApiMode.vue").default);
Vue.component("auto-logout", require("./components/AutoLogout.vue").default);
Vue.component("alert-container", require("./components/AlertContainer.vue").default);
Vue.component("AppAlert", require("./components/AppAlert.vue").default);
Vue.component("AppDistributionBar", require("./components/AppDistributionBar.vue").default);
Vue.component("AppLink", require("./components/AppLink.vue").default);
Vue.component("AppMetricPercent", require("./components/AppMetricPercent.vue").default);
Vue.component("AppMetricNumber", require("./components/AppMetricNumber.vue").default);
Vue.component("AppKeyCombination", require("./components/AppKeyCombination.vue").default);
Vue.component("alert", require("./components/Alert.vue").default);
Vue.component("active-call", require("./components/ActiveCall.vue").default);
Vue.component("register-confirm-form", require("./components/forms/RegisterConfirmForm.vue").default);
Vue.component("register-resend-confirmation-email-form", require("./components/forms/RegisterResendConfirmationEmailForm.vue").default);
Vue.component("complete-instruction-form", require("./components/forms/CompleteInstructionForm.vue").default);
Vue.component("id-check-form", require("./components/forms/IdCheckForm.vue").default);
Vue.component("search-pack-form", require("./components/forms/SearchPackForm.vue").default);
Vue.component("v-contextual", require("./common/components/v-contextual/v-contextual.vue").default);
Vue.component("v-contextual-content", require("./common/components/v-contextual/v-contextual-content.vue").default);
Vue.component("v-contextual-option", require("./common/components/v-contextual/v-contextual-option.vue").default);
Vue.component("v-upload", require("./common/components/v-upload/v-upload.vue").default);
Vue.component("checkbox-manager", require("./components/CheckboxManager.vue").default);
Vue.component("process-button", require("./components/ProcessButton.vue").default);
Vue.component("loader", require("./components/GenericLoader.vue").default);
Vue.component("bool-icon", require("./components/BoolIcon.vue").default);
Vue.component("requirement-icon", require("./components/RequirementIcon.vue").default);
Vue.component("activity-icon", require("./components/ActivityIcon.vue").default);
Vue.component("progress-indicator", require("./components/ProgressIndicator.vue").default);
Vue.component("status-badge", require("./components/StatusBadge.vue").default);
Vue.component("task", require("./components/Task.vue").default);
// Vue.component('participants', require('./components/Participants.vue').default)
Vue.component("v-tabs", require("./common/components/v-tabs/v-tabs.vue").default);
Vue.component("v-tab", require("./common/components/v-tabs/v-tab.vue").default);
// Vue.component('v-tab', require('./components/v-tabs/v-tab.vue').default)
// Vue.component("v-datepicker", require("./common/components/v-datepicker/v-datepicker.vue").default);
// Vue.component("v-datepicker-calendar", require("./common/components/v-datepicker/v-datepicker-calendar.vue").default);
Vue.component("v-dobpicker", require("./common/components/v-dobpicker/v-dobpicker").default);
Vue.component("v-tags", require("./common/components/v-tags/v-tags.vue").default);
Vue.component("v-typeahead", require("./common/components/v-typeahead/v-typeahead.vue").default);
Vue.component("v-table", require("./common/components/v-table/v-table.vue").default);
Vue.component("v-store-table", require("./common/components/v-table/v-store-table.vue").default);
// Vue.component("v-resource-timeline", require("./components/calendars/resource-timeline/v-resource-timeline.vue").default);
// Vue.component("v-event-calendar", require("./components/calendars/event-calendar/v-event-calendar.vue").default);
// Vue.component("v-main-calendar", require("./components/calendars/v-main-calendar.vue").default);
Vue.component("v-fact-find-response-modal", require("./components/modals/v-fact-find-response-modal.vue").default);
// Vue.component("v-event-modal", require("./components/modals/event.vue").default);
Vue.component("table-filter", require("./common/components/v-table/v-table-filters.vue").default);
Vue.component("paginator", require("@/common/components/v-table/Paginator.vue").default);
Vue.component("comparison--property-listing", require("./components/ComparisonPropertyListing.vue").default);
Vue.component("comparison--conveyancing", require("./components/ComparisonConveyancing.vue").default);
Vue.component("money", require("./components/Money.vue").default);
Vue.component("comparison", require("./apps/portal/views/comparison/Comparison.vue").default);
Vue.component("postcode-manager-list", require("./apps/portal/views/tools/PostcodeManagerList.vue").default);
Vue.component("v-tooltip", require("./common/components/v-tooltip/v-tooltip").default);
Vue.component("v-modal", require("./components/v-modal.vue").default);
Vue.component("app-link", require("./components/AppLink.vue").default);

Vue.mixin(authed);
Vue.mixin(form(http(), store));
Vue.mixin(route);
Vue.mixin(StringerMixin);
Vue.mixin(permissions);
Vue.mixin(present);
Vue.mixin(refs);
Vue.mixin(enums);
Vue.mixin(scrollTo);
Vue.mixin(manageKeyBindings);

Vue.mixin(bus(new eventHandler(http(), store, spaEvents)));

Vue.use(vmodal, {
	component: () => import("./components/v-modal.vue"),
	opacity: "1",
	backgroundColor: "rgba(45, 51, 61, .85)",
	animation: "slideBottom",
});
Vue.use(VCalendar, {});
Vue.use(VueScrollTo);
Vue.use(VueTheMask);
Vue.use(tween);

// window.Pusher = Pusher;
// window.Echo = new Echo({
// 	broadcaster: "pusher",
// 	cluster: process.env.MIX_PUSHER_APP_CLUSTER,
// 	encrypted: true,
// 	forceTLS: true,
// 	key: process.env.MIX_PUSHER_APP_KEY,
// 	namespace: "App.Core.Events",
// 	authorizer: (channel, options) => {
// 		return {
// 			authorize: (socketId, callback) => {
// 				http().post("/broadcasting/auth", {
// 					socket_id: socketId,
// 					channel_name: channel.name,
// 				})
// 					.then(response => {
// 						callback(false, response.data);
// 					})
// 					.catch(error => {
// 						callback(true, error);
// 					});
// 			},
// 		};
// 	},
// });

window.app = new Vue({
	el: "#app",
	router,
	store,
	created() {
		this.$store.dispatch("authStore/authed");
	},
});
